import { merge, delay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { generateLpSymbolsRoute } from '@cbridge-packages/routing-client-admin';
import { SymbolLpAction } from '@cbridge-packages/symbol-lp';

export const toggleViewSymbolLpSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(SymbolLpAction.create.done),
    delay(100),
    map(({ params }) => RouterAction.replace([generateLpSymbolsRoute(params.lpId, params.data.name)])),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(SymbolLpAction.update.done),
    // Let the form settle after `resolve()`: a rename navigates while RHF has not yet recorded the successful submit
    // and the unsaved-changes guard would block the redirect
    delay(100),
    map(({ params }) => RouterAction.replace([generateLpSymbolsRoute(params.lpId, params.data.name)])),
  ),
);
